import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { RequisitoClientesContent } from './components/RequisitoClientesContent';

export default function RequisitoClientes() {
    return (
        <>
            <MainContent
                component={<RequisitoClientesContent />}
                titulo='Requisito de Clientes'
                noBackground
                tableMaxWidth
            />
        </>
    );

};
